import { types } from '../../actions'

function getFees(seasons){
	const seasonDivisions = {}

	seasons.map(function(season) {
      const { id,divisions, offerGenderDivisionOptions, isSeasonSet, minRequiredDeposit } = season
			const division = {
				seasonId: id,
				divisions,
				offerGenderDivisionOptions,
        minRequiredDeposit:minRequiredDeposit ? minRequiredDeposit.toFixed(2): null,
				isSeasonSet
			}
			seasonDivisions[id] = division
	})

	return seasonDivisions
}
    
   export default function seasonfees(state,action) {
        const { payload } = action
        
        switch(action.type) {          
            case types.Season.FETCH_ACTIVE_SEASONS: {           
                const { data } = payload
                if (data) {                
                    const defaultId = payload.data[0].id
										const fees = getFees(data)
										const newstate = {
											fees,
											settingsseason:defaultId,
											initialstate:fees,
										}
                   
                    return Object.assign({},state,{ values: newstate, fields:newstate })
                }
                else {
                    return state
                }
            }
            case types.Season.TRIGGER_SEASON: {           
              const { data } = payload
              if (data) {                
                  const defaultId = payload.data[data.length - 1].id
                  const fees = getFees(data)
                  const newstate = {
                    fees,
                    settingsseason:defaultId,
                    initialstate:fees,
                  }
                 
                  return Object.assign({},state,{ values: newstate, fields:newstate })
              }
              else {
                  return state
              }
          }
          case types.Season.SAVE_SEASON_FEE: {
           
           const datasaved  = true 
           const savingdata = false
           const isSettingSeason = false

           const response = {
            savingdata,
            datasaved,
            isSettingSeason,
            initialstate:state.values.fees
           }

           return  { ...state, 
              values: {
                        ...state.values ,
                        ...response        
                      },
              fields: {
                        ...state.fields,
                        ...response 
                      }
            }
          
          }
          case types.Season.SAVING_SEASON_DIVISION: {
            const response = {
              savingfee: true,
             }
  
             return  { ...state, 
                values: {
                          ...state.values ,
                          ...response        
                        },
                fields: {
                          ...state.fields,
                          ...response 
                        }
              }
          }
          case types.Season.SAVE_SEASON_DIVISION: {
           const datasaved  = true 
           const savingfee = false
           const isSettingSeason = false
           const response = {
            savingfee,
            datasaved,
            isSettingSeason,
            initialstate:state.values.divisions
           }
           return  { ...state, 
              values: {
                        ...state.values ,
                        ...response        
                      },
              fields: {
                        ...state.fields,
                        ...response 
                      }
            }
          
          }
          default: return state
        }
      } 


// WEBPACK FOOTER //
// ./src/redux/reducers/forms/seasonfees.js